import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { initGA, initClarity } from "../utils/analytics";

const GA_ID = "G-T48SLN40KQ";
const CLARITY_ID = "wjqdnik3so";

export function CookieConsent() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie-consent");
    if (!consent) {
      setIsVisible(true);
    } else if (consent === "accepted") {
      initGA(GA_ID);
      initClarity(CLARITY_ID);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookie-consent", "accepted");
    initGA(GA_ID);
    initClarity(CLARITY_ID);
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div
      style={{
        position: "fixed",
        bottom: "24px",
        left: "24px",
        right: "24px",
        zIndex: 2000,
        background: "#1e293b",
        border: "1px solid rgba(255, 255, 255, 0.1)",
        borderRadius: "16px",
        padding: "20px",
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        boxShadow: "0 10px 30px rgba(0, 0, 0, 0.5)",
        backdropFilter: "blur(10px)",
        maxWidth: "500px",
        margin: "0 auto",
      }}
    >
      <div style={{ color: "white", fontSize: "0.95rem", lineHeight: "1.5" }}>
        We use cookies and third-party services (Google Analytics and Microsoft Clarity) to improve
        your experience. By using our site, you agree to our{" "}
        <Link
          to="/privacy"
          style={{
            color: "var(--accent-blue)",
            textDecoration: "none",
            fontWeight: "600",
          }}
        >
          Privacy Policy
        </Link>
        .
      </div>
      <div style={{ display: "flex", gap: "12px" }}>
        <button
          onClick={handleAccept}
          style={{
            flex: 1,
            background: "var(--accent-blue)",
            color: "white",
            border: "none",
            padding: "10px",
            borderRadius: "8px",
            fontWeight: "600",
            cursor: "pointer",
          }}
        >
          Accept
        </button>
        <button
          onClick={() => setIsVisible(false)}
          style={{
            background: "rgba(255, 255, 255, 0.1)",
            color: "white",
            border: "none",
            padding: "10px 20px",
            borderRadius: "8px",
            fontWeight: "600",
            cursor: "pointer",
          }}
        >
          Decline
        </button>
      </div>
    </div>
  );
}
